<div class="bg-white rounded-tl-lg rounded-tr-lg text-dark-grey overflow-hidden">
  <app-modal-header
    title="Teilnehmerübersicht"
    iconPath="assets/icons/calendar-dots-light.svg"
  />

  <mat-dialog-content>
    <div class="border-b border-light-grey">
      @for (user of sortedUsers(); track user.id) {
        <div class="flex justify-between items-center p-2 border-t border-light-grey">
          <div class="flex flex-col justify-between items-start">
            <span>{{ user.lastname }}</span>
            <span>{{ user.firstname }}</span>
          </div>

          <span>{{ user.email }}</span>
        </div>
      }
    </div>
  </mat-dialog-content>
</div>
